  <script setup>
  import ButtonSubmit from "./ButtonSubmit.vue";
  import api from "../api/api";
  import HomeViewSampleReport from "./HomeViewSampleReport.vue";
  </script>
  <template>
    <div class="main-div">
      <div class="card-header">
        <div class="card-header-title">
          {{ label }}
          <span v-if="filterBreadcrumb" class="card-header-breadcrumb">{{ filterBreadcrumb }}</span>
        </div>
        <div style="display: flex; align-items: center; gap: 8px;">
          <button class="pill-btn" @click.prevent="toggle = !toggle" v-show="!toggle">Show</button>
          <button class="pill-btn" @click.prevent="toggle = !toggle" v-show="toggle">Hide</button>
        </div>
      </div>
      <div
        class="parent"
        v-show="toggle"
        v-if="filteredAllReports.length == 0"
      >
        <h2>No faculty report(s) available.</h2>
      </div>
      <div class="parent" v-show="toggle" v-if="filteredAllReports.length > 0">
        <div
          class="child"
          style="background-color: #cdcdcd"
          v-for="report in paginatedReports"
          :key="report"
        >
          <div>
            <p>{{ report.program_name }}</p>
            <h2>{{ report.iteration_name }}</h2>
            <h2>{{ report.report_template_name }}</h2>
          </div>
          <div v-if="report.survey_type == 1">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/big5_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 2">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/360_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 3">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/research_survey_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 7">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/tipping_point_logo.png"
            />
          </div>
          <div v-if="report.survey_type == 8">
            <img
              class="surveyLogo"
              src="../../public/survey_logo/pressure_point_logo.png"
            />
          </div>

          <!--Team Leader 360-->
          <a
            v-if="report.report_file == 'TeamLeader360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'TeamLeader360Report.html',
                14850,
                'Sample User',
                38,
                61,
                1,
                17,
                31
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'TeamLeader360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'TeamLeader360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--General Manager 360-->
          <a
            v-if="report.report_file == 'GeneralManager360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'GeneralManager360Report.html',
                14846,
                'Sample User',
                38,
                60,
                1,
                17,
                25
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'GeneralManager360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'GeneralManager360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Alba 360-->
          <a
            v-if="report.report_file == 'ALBATeamLeader360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'ALBATeamLeader360FacultyReport.html',
                14846,
                'Sample User',
                38,
                60,
                1,
                17,
                25
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'ALBATeamLeader360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'ALBATeamLeader360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />
          
          <a
            v-if="report.report_file == 'ALBAGeneralManager360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'ALBAGeneralManager360FacultyReport.html',
                14846,
                'Sample User',
                38,
                60,
                1,
                17,
                25
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'ALBAGeneralManager360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'ALBAGeneralManager360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--SEP 360 report-->
          <a
            v-if="report.report_file == 'SeniorExecProgram360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'SeniorExecProgram360Report.html',
                14848,
                'Sample User',
                38,
                63,
                1,
                17,
                27
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'SeniorExecProgram360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'SeniorExecProgram360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--TalentSage 360 report-->
          <a
            v-if="report.report_file == 'TalentSage360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'TalentSage360Report.html',
                14849,
                'Sample User',
                38,
                59,
                1,
                17,
                29
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'TalentSage360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'TalentSage360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--HELP 360 report-->
          <a
            v-if="report.report_file == 'HELP360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'HELP360Report.html',
                14847,
                'Sample User',
                38,
                62,
                1,
                17,
                33
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'HELP360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'HELP360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--EuroNav360-->
          <a
            v-if="report.report_file == 'EURONAV360FacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'EURONAV360Report.html',
                survey_assignment_id,
                'Sample User',
                38,
                61,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'EURONAV360FacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'EURONAV360FacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Big five or Big 5 view report button-->
          <a
            v-if="report.report_file == '5StepFacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                '5Step.html',
                14845,
                'Sample User',
                38,
                64,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == '5StepFacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == '5StepFacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Tipping Point report-->
          <a
            v-if="report.report_file == 'TIPpingPointFacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'TIPpingPointReport.html',
                14845,
                'Sample User',
                38,
                64,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'TIPpingPointFacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'TIPpingPointFacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <!--Pressure Point report-->
          <a
            v-if="report.report_file == 'PressurePointFacultyReport.html'"
            class="sample-report-href"
            @click="
              showFacultySampleReport(
                'PressurePointReport.html',
                14845,
                'Sample User',
                38,
                64,
                1,
                17,
                23
              )
            "
          >View Sample Report</a>

          <a
            class="btn-submit"
            v-if="
              report.dropped_status == 0 &&
              report.report_file == 'PressurePointFacultyReport.html'
            "
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >View Faculty Report</a>

          <ButtonSubmit
            v-if="
              report.dropped_status == 1 &&
              report.report_file == 'PressurePointFacultyReport.html'
            "
            disabled
            label="Dropped"
            style="margin-top: 10px"
          />

          <div
            class="tooltip"
            v-if="facultyOrg && facultySuborg"
            style="margin-top: 10px"
          >
            Information
            <span class="tooltiptext"
              >- Above this tooltip shows exactly what the coach see in their
              report tile screen.
              <br />
              <br />- This tooltip and the button under this only shows for Admin
              to view the report.</span
            >
          </div>

          <a
            class="btn-submit"
            v-if="facultyOrg && facultySuborg"
            :href="`${
              brandData.website_url + report.report_file
            }?report_for_fullname=${
              userData.first_name + ' ' + userData.last_name
            }&survey_assignment_id=${report.survey_assignment_id}&org_id=${
              report.org_id
            }&subOrg_id=${report.suborg_id}&program_id=${
              report.program_id
            }&iteration_id=${report.iteration_id}&survey_template_id=${
              report.survey_template_id
            }&suborg_name=${report.suborg_name}&program_name=${
              report.program_name
            }&iteration_name=${report.iteration_name}`"
            target="_blank"
          >Admin access to report</a>
        </div>
      </div>

      <div v-if="filteredAllReports.length > 0 && totalPages > 1" class="pagination-container">
        <button 
          class="pagination-btn" 
          :disabled="currentPage === 1"
          @click="goToPage(currentPage - 1)">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <button 
          v-for="page in displayedPages" 
          :key="page"
          class="pagination-btn"
          :class="{ 'active': page === currentPage }"
          @click="goToPage(page)">
          {{ page }}
        </button>
        
        <button 
          class="pagination-btn" 
          :disabled="currentPage === totalPages"
          @click="goToPage(currentPage + 1)">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
        
        <div class="pagination-info">
          Page {{ currentPage }} of {{ totalPages }} 
          <span v-if="activeFilters">({{ filteredAllReports.length }} filtered / {{ allReports.length }} total)</span>
          <span v-else>({{ allReports.length }} total reports)</span>
        </div>
      </div>

      <HomeViewSampleReport
        v-if="showFacultySampleModal == true"
        @close-modal="showFacultySampleModal = false"
        :surveyAssignmentId="survey_assignment_id"
        :suborg="suborg_id"
        :surveyTemplateId="survey_template_id"
        :programId="program_id"
        :iterationId="iteration_id"
        :orgId="org_id"
        :suborgName="suborg_name"
        :programName="program_name"
        :iterationName="iteration_name"
        :reportForFullName="report_for_fullname"
        :viewerFullName="viewer_fullname"
        :reportLink="report_link"
        :brandData="brandData"
        :userData="userData"
      />
    </div>
  </template>
  <script>
  export default {
    components: [ButtonSubmit, HomeViewSampleReport],
    name: "HomeFacultyReport",
    data: () => ({
      toggle: true,
      reportData: [],
      facultyIteration: "",
      joinSuborg: "",
      showFacultySampleModal: false,
      report_link: "",
      org_id: "",
      suborg_id: "",
      survey_template_id: "",
      program_id: "",
      iteration_id: "",
      suborg_name: "",
      program_name: "",
      iteration_name: "",
      report_for_fullname: "",
      survey_assignment_id: 0,
      viewer_fullname: "",
      currentPage: 1,
      itemsPerPage: 10,
    }),
    watch: {
      activeFilters: {
        handler() {
          this.currentPage = 1;
        },
        deep: true
      }
    },
    async mounted() {
      if (this.facultyOrg && this.facultySuborg) {
        await api
          .get(`get-faculty-reports/${this.facultyOrg}/${this.facultySuborg}`)
          .then((res) => {
            this.reportData = res.data;
          });
      } else {
        var array = this.userData.suborgs.split(",");
        this.joinSuborg = array.join(",");

        await api
          .get(`get-faculty-reports/${this.userData.org_id}/${this.joinSuborg}`)
          .then((res) => {
            this.reportData = res.data;
          });
      }
    },
    props: [
      "userData",
      "brandData",
      "reportName",
      "surveyName",
      "dateTime",
      "buttonLabel",
      "label",
      "buttonColor",
      "facultyOrg",
      "facultySuborg",
      "activeFilters",
    ],

    methods: {
      goToPage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          const parentDiv = this.$el.querySelector('.parent');
          if (parentDiv) {
            parentDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      },
      myReport(
        report_suborg_name,
        report_program_name,
        report_iteration_name,
        report_file,
        report_program_id,
        report_iteration_id,
        report_org_id,
        report_suborg_id,
        report_survey_template_id
      ) {
        // get sex and country first
        let data;

        data = {
          report_link: this.brandData.website_url + report_file,
          report_for_fullname:
            this.userData.first_name + " " + this.userData.last_name,
          org_id: report_org_id,
          suborg_id: report_suborg_id,
          program_id: report_program_id,
          iteration_id: report_iteration_id,
          survey_template_id: report_survey_template_id,
          ind_id: this.userData.ind_id,
          suborg_name: report_suborg_name,
          program_name: report_program_name,
          iteration_name: report_iteration_name,
        };
        this.$router.push({
          name: "MyReport",
          params: { data: JSON.stringify(data) },
        });
      },

      showFacultySampleReport(
        report_file,
        survey_assignment_id,
        full_name,
        program_id,
        iteration_id,
        org_id,
        suborg_id,
        survey_template_id
      ) {
        this.showFacultySampleModal = true;
        this.viewer_fullname =
          this.userData.first_name + " " + this.userData.last_name;
        this.report_for_fullname = full_name;
        this.report_link = this.brandData.website_url + report_file;
        this.suborg_id = suborg_id;
        this.survey_template_id = survey_template_id;
        this.program_id = program_id;
        this.iteration_id = iteration_id;
        this.org_id = org_id;
        this.survey_assignment_id = survey_assignment_id;
      },
    },

    computed: {
      filterBreadcrumb() {
        if (!this.activeFilters) {
          return '';
        }

        const parts = [];
        
        // Organization
        if (this.activeFilters.organization) {
          parts.push(this.activeFilters.organization.name);
          
          // Sub-Organization
          if (this.activeFilters.subOrganization) {
            parts.push(this.activeFilters.subOrganization.name);
            
            // Program
            if (this.activeFilters.program) {
              parts.push(this.activeFilters.program.name);
              
              // Iteration
              if (this.activeFilters.iteration) {
                parts.push(this.activeFilters.iteration.name);
                
                // Stream
                if (this.activeFilters.stream) {
                  parts.push(this.activeFilters.stream.name);
                  
                  // Group
                  if (this.activeFilters.group) {
                    parts.push(this.activeFilters.group.name);
                  } else {
                    const groupCount = this.activeFilters.stream.groups?.length || 0;
                    if (groupCount > 1) {
                      parts.push('many');
                    }
                  }
                } else {
                  const streamCount = this.activeFilters.iteration.streams?.length || 0;
                  if (streamCount > 1) {
                    parts.push('many');
                  }
                }
              } else {
                const iterationCount = this.activeFilters.program.iterations?.length || 0;
                if (iterationCount > 1) {
                  parts.push('many');
                }
              }
            } else {
              const programCount = this.activeFilters.subOrganization.programs?.length || 0;
              if (programCount > 1) {
                parts.push('many');
              }
            }
          } else {
            const subOrgCount = this.activeFilters.organization.subOrgs?.length || 0;
            if (subOrgCount > 1) {
              parts.push('many');
            }
          }
        }
        
        return parts.join(' / ');
      },

      applyFiltersToReports() {
        return (reports) => {
          if (!this.activeFilters) return reports;

          return reports.filter(report => {
            if (this.activeFilters.organization && report.org_id !== this.activeFilters.organization.id) return false;
            if (this.activeFilters.subOrganization && report.suborg_id !== this.activeFilters.subOrganization.id) return false;
            if (this.activeFilters.program && report.program_id !== this.activeFilters.program.id) return false;
            if (this.activeFilters.iteration && report.iteration_id !== this.activeFilters.iteration.id) return false;
            if (this.activeFilters.stream && report.stream_id !== this.activeFilters.stream.id) return false;
            if (this.activeFilters.group && report.group_id !== this.activeFilters.group.id) return false;

            if (this.activeFilters.searchQuery) {
              const query = this.activeFilters.searchQuery.toLowerCase();
              const programName = report.program_name?.toLowerCase() || '';
              const iterationName = report.iteration_name?.toLowerCase() || '';
              const reportName = report.report_template_name?.toLowerCase() || '';
              const suborgName = report.suborg_name?.toLowerCase() || '';
              
              if (!programName.includes(query) && !iterationName.includes(query) && 
                  !reportName.includes(query) && !suborgName.includes(query)) {
                return false;
              }
            }
            return true;
          });
        };
      },

      allReports: function () {
        return this.reportData.sort((a, b) =>
          b.survey_assignment_id - a.survey_assignment_id
        );
      },

      filteredAllReports() {
        return this.applyFiltersToReports(this.allReports);
      },

      totalPages() {
        return Math.ceil(this.filteredAllReports.length / this.itemsPerPage);
      },

      paginatedReports() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredAllReports.slice(start, end);
      },

      displayedPages() {
        const pages = [];
        const maxVisible = 5;
        
        if (this.totalPages <= maxVisible) {
          for (let i = 1; i <= this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          if (this.currentPage <= 3) {
            for (let i = 1; i <= 4; i++) {
              pages.push(i);
            }
            pages.push('...');
            pages.push(this.totalPages);
          } else if (this.currentPage >= this.totalPages - 2) {
            pages.push(1);
            pages.push('...');
            for (let i = this.totalPages - 3; i <= this.totalPages; i++) {
              pages.push(i);
            }
          } else {
            pages.push(1);
            pages.push('...');
            pages.push(this.currentPage - 1);
            pages.push(this.currentPage);
            pages.push(this.currentPage + 1);
            pages.push('...');
            pages.push(this.totalPages);
          }
        }
        
        return pages;
      },
    },
  };
  </script>

<style scoped>
.main-div {
  min-width: 75vw;
  margin: 0;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.card-header {
  padding: var(--space-sm, 16px);
  background: var(--card-bg, #ffffff);
  border: 1px solid var(--card-border, #e2e8f0);
  border-bottom: none;
  border-radius: var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem) 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.card-header-title {
  font-size: var(--label-md-size, 12px);
  font-weight: 600;
  letter-spacing: var(--label-md-tracking, 0.05em);
  text-transform: uppercase;
  color: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
}
.pill-btn {
  background: #ffffff;
  color: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  border: 1px solid v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  border-radius: 9999px;
  padding: 6px 16px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
  font-family: var(--font-family, 'Inter', sans-serif);
  text-transform: none;
  letter-spacing: 0;
  white-space: nowrap;
  flex-shrink: 0;
}
.pill-btn:hover {
  background: v-bind('brandData.main_color1 ? brandData.main_color1 : "#002955"');
  color: #ffffff;
}
h4 { margin: 0; color: var(--primary, #002955); }
.label-btn {
  color: var(--on-primary, #ffffff);
  background-color: var(--primary, #002955);
}
.parent {
  display: flex;
  flex-wrap: wrap;
  padding: var(--space-sm, 16px);
  padding-bottom: var(--space-md, 24px);
  border: 1px solid var(--card-border, #e2e8f0);
  border-top: none;
  border-radius: 0 0 var(--radius-lg, 0.5rem) var(--radius-lg, 0.5rem);
  box-shadow: none;
  background: var(--card-bg, #ffffff);
}
.parent:hover {
  border-color: var(--primary-container, #123f75);
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
}
.child {
  background: var(--surface-container-low, #eff4ff) !important;
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  width: 250px;
  min-width: 250px;
  min-height: 400px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: none;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}
.child:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.child-submitted {
  background: var(--surface-container, #e5eeff) !important;
  border: 1px solid var(--card-border, #e2e8f0);
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
  min-width: 205px;
  max-width: 205px;
  margin: var(--space-xs, 8px);
  padding: var(--space-sm, 16px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: none;
}
.child-submitted:hover {
  box-shadow: var(--shadow-hover, 0px 4px 20px rgba(18, 63, 117, 0.05));
  border-color: var(--primary-container, #123f75);
}
.surveyLogo { width: 150px; height: auto; }
.btn-submit { text-decoration: none; }

.tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;
  color: var(--outline, #737781);
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 150px;
  background-color: var(--inverse-surface, #213145);
  color: var(--inverse-on-surface, #eaf1ff);
  text-align: center;
  border-radius: var(--radius, 0.25rem);
  padding: 10px 6px;
  position: absolute;
  z-index: 1;
  font-size: 12px;
}
.tooltip:hover .tooltiptext { visibility: visible; }

.sample-report-href {
  text-decoration: none;
  cursor: pointer;
  color: var(--secondary, #36618b);
  font-weight: 500;
}
@media only screen and (min-width: 280px) and (max-width: 540px) {
  .main-div { margin: 0; }
}
.pagination-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: var(--space-md, 24px);
  padding: var(--space-md, 24px) var(--space-xs, 8px);
  flex-wrap: wrap;
}
.pagination-btn {
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--outline-variant, #c3c6d1);
  background-color: var(--card-bg, #ffffff);
  color: var(--on-surface, #0b1c30);
  border-radius: var(--radius, 0.25rem);
  cursor: pointer;
  font-size: var(--body-md-size, 14px);
  font-weight: 500;
  transition: all 0.2s ease;
  padding: 0 12px;
  font-family: var(--font-family, 'Inter', sans-serif);
}
.pagination-btn:hover:not(:disabled):not(.active) {
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  border-color: var(--primary, #002955);
}
.pagination-btn.active {
  background-color: var(--primary, #002955);
  color: var(--on-primary, #ffffff);
  border-color: var(--primary, #002955);
  font-weight: 600;
}
.pagination-btn:disabled {
  background-color: var(--surface-container-low, #eff4ff);
  color: var(--outline-variant, #c3c6d1);
  cursor: not-allowed;
  border-color: var(--row-divider, #f1f5f9);
}
.pagination-info {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-size: 13px;
  color: var(--on-surface-variant, #434750);
  font-family: var(--font-family, 'Inter', sans-serif);
}
</style>
